import React from 'react';
import ReactDOM from 'react-dom';
import { App } from './modules/App/App';
import 'normalize.css';
import './main.global.sass';

ReactDOM.render(<App />, document.getElementById('root'));
